import { render, staticRenderFns } from "./settingsCard.vue?vue&type=template&id=7577feb8"
import script from "./settingsCard.vue?vue&type=script&lang=js"
export * from "./settingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports